var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / \xD0\x9F\xD0\xB0\xD1\x80\xD0\xBA\xD0\xBE\xD0\xB2\xD0\xBA\xD0\xB0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.4165 27.0835H16.6665M4.1665 18.7502L8.33317 20.8335L10.9803 12.892C11.5267 11.2528 11.7999 10.4332 12.3067 9.82721C12.7542 9.29211 13.3288 8.87792 13.978 8.62261C14.7131 8.3335 15.577 8.3335 17.3049 8.3335H32.6948C34.4227 8.3335 35.2866 8.3335 36.0217 8.62261C36.6708 8.87792 37.2455 9.29211 37.693 9.82721C38.1997 10.4332 38.4729 11.2528 39.0193 12.892L41.6665 20.8335L45.8332 18.7502M33.3332 27.0835H39.5832M14.1665 20.8335H35.8332C39.3335 20.8335 41.0837 20.8335 42.4206 21.5147C43.5966 22.1139 44.5528 23.07 45.152 24.2461C45.8332 25.583 45.8332 27.3332 45.8332 30.8335V36.4585C45.8332 37.4265 45.8332 37.9105 45.7531 38.313C45.4243 39.9659 44.1323 41.258 42.4794 41.5868C42.0769 41.6668 41.5929 41.6668 40.6248 41.6668H39.5832C37.282 41.6668 35.4165 39.8014 35.4165 37.5002C35.4165 36.9249 34.9501 36.4585 34.3748 36.4585H15.6248C15.0495 36.4585 14.5832 36.9249 14.5832 37.5002C14.5832 39.8014 12.7177 41.6668 10.4165 41.6668H9.37484C8.40681 41.6668 7.92279 41.6668 7.52029 41.5868C5.86742 41.258 4.57534 39.9659 4.24657 38.313C4.1665 37.9105 4.1665 37.4265 4.1665 36.4585V30.8335C4.1665 27.3332 4.1665 25.583 4.84771 24.2461C5.44692 23.07 6.40305 22.1139 7.57906 21.5147C8.91601 20.8335 10.6662 20.8335 14.1665 20.8335Z",
    stroke: "#956446",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.6ab9458df403b964cc59d5157e7a4b7e.svg";
export { ForwardRef as ReactComponent };